{
    "GUI": {
        "IndexScript": {
            "ID": "index-script",
            "ClassList": []
        },
        "Stylesheets": {
            "ID": "stylesheet",
            "ClassList": [],
            "StylesheetsDir": "/static/css/",
            "Stylesheets": [
                "index.css",
                "light_theme.css",
                "dark_theme.css"
            ]
        },
        "Metadata": {
            "Title": "VacuumWorld",
            "LockedInClassName": "locked-in",
            "HighlightedClassName": "highlighted",
            "SelectedClassName": "selected",
            "DropZoneClassName": "drop-zone"
        },
        "Auth": {
            "AuthPath": "/auth/",
            "AuthServerURL": "https://agent-auth.dicelab-rhul.org",
            "OAuth20ExchangePath": "/auth/exchange/",
            "OAuth20ClientName": "VacuumWorld",
            "OAuth20RedirectURL": "https://vacuumworld.dicelab-rhul.org/post-auth/",
            "OAuth20PostAuthRedirectURL": "https://vacuumworld.dicelab-rhul.org/"
        },
        "VWCookieConsentDiv": {
            "ID": "cookie-consent-div",
            "ClassList": [
                "cookie-consent-div"
            ],
            "ClassListLight": [
                "cookie-consent-div-light"
            ],
            "ClassListDark": [
                "cookie-consent-div-dark"
            ],
            "WebAgentCookieConsentLabel": {
                "ID": "cookie-consent-label",
                "ClassList": [
                    "cookie-consent-label"
                ],
                "ClassListLight": [
                    "cookie-consent-label-light"
                ],
                "ClassListDark": [
                    "cookie-consent-label-dark"
                ],
                "Text": "This website uses first-party cookies to maintain user sessions, to authenticate users to the API server, and to mitigate CSRF attacks during authentication. By clicking on the button below, you consent to the use of such cookies. Your consent will be stored in a cookie as well. All cookies are marked as secure, httpOnly, and SameSite=Strict. As all cookies are essential for the functioning of this website, your only possible opt-out is to stop using this website right now."
            },
            "WebAgentCookieConsentButton": {
                "ID": "cookie-consent-button",
                "ClassList": [
                    "cookie-consent-button"
                ],
                "ClassListLight": [
                    "cookie-consent-button-light"
                ],
                "ClassListDark": [
                    "cookie-consent-button-dark"
                ],
                "Text": "Got it!",
                "Title": "Accept cookies and close this message."
            }
        },
        "AuthenticationDiv": {
            "ID": "authentication-div",
            "ClassList": [
                "center-aligned"
            ],
            "VWImage": {
                "ID": "vw-image",
                "ClassList": [],
                "Src": "static/images/start_menu.png"
            },
            "AuthenticationButton": {
                "ID": "authentication-button",
                "ClassList": [],
                "ClassListLight": [
                    "authentication-button-light"
                ],
                "ClassListDark": [
                    "authentication-button-dark"
                ],
                "Text": "Authenticate",
                "Title": "Authenticate with OAuth2.0."
            }
        },
        "WelcomeDiv": {
            "ID": "welcome-div",
            "ClassList": [
                "center-aligned"
            ],
            "ClassListLight": [
                "welcome-div-light"
            ],
            "ClassListDark": [
                "welcome-div-dark"
            ]
        },
        "PlatformDiv": {
            "ID": "platform-div",
            "ClassList": [
                "platform-div",
                "center-aligned"
            ],
            "ClassListLight": [
                "platform-div-light"
            ],
            "ClassListDark": [
                "platform-div-dark"
            ],
            "InitialGUI": {
                "InitialDiv": {
                    "ID": "initial-div",
                    "ClassList": [],
                    "InitialDivImage": {
                        "ID": "initial-div-image",
                        "ClassList": [],
                        "Src": "static/images/start_menu.png"
                    }
                },
                "InitialControlsDiv": {
                    "ID": "initial-controls-div",
                    "ClassList": [],
                    "StartButton": {
                        "ID": "start-button",
                        "ClassList": [
                            "initial-buttons"
                        ],
                        "ClassListLight": [
                            "initial-buttons-light"
                        ],
                        "ClassListDark": [
                            "initial-buttons-dark"
                        ],
                        "Text": "Start",
                        "Title": "Display the simulation view"
                    },
                    "OptionsButton": {
                        "ID": "options-button",
                        "ClassList": [
                            "initial-buttons"
                        ],
                        "ClassListLight": [
                            "initial-buttons-light"
                        ],
                        "ClassListDark": [
                            "initial-buttons-dark"
                        ],
                        "Text": "Options",
                        "Title": "Choose the simulation options"
                    },
                    "GuideButton": {
                        "ID": "outer-guide-button",
                        "ClassList": [
                            "initial-buttons"
                        ],
                        "ClassListLight": [
                            "initial-buttons-light"
                        ],
                        "ClassListDark": [
                            "initial-buttons-dark"
                        ],
                        "Text": "Guide",
                        "Title": "Show the guide in a new browser tab.",
                        "URL": "https://github.com/dicelab-rhul/vacuumworld-web-gui/wiki"
                    }
                },
                "OptionsDiv": {
                    "ID": "options-dialog-div",
                    "ClassList": [],
                    "OptionsDialog": {
                        "ID": "options-dialog",
                        "ClassList": [
                            "options-dialog"
                        ],
                        "SpeedSelectorDiv": {
                            "ID": "speed-selector-div",
                            "ClassList": [
                                "options-dialog-element"
                            ],
                            "SpeedSelectorLabel": {
                                "ID": "speed-selector-label",
                                "ClassList": [
                                    "options-dialog-label"
                                ],
                                "Text": "Speed"
                            },
                            "SpeedSelector": {
                                "ID": "speed-selector",
                                "ClassList": [
                                    "options-dialog-sub-element"
                                ],
                                "SpeedSelectorOption": {
                                    "IDPrefix": "speed-value-"
                                }
                            }
                        },
                        "AutoplayCheckboxDiv": {
                            "ID": "autoplay-checkbox-div",
                            "ClassList": [
                                "options-dialog-element"
                            ],
                            "AutoplayCheckboxLabel": {
                                "ID": "autoplay-checkbox-label",
                                "ClassList": [
                                    "options-dialog-label"
                                ],
                                "Text": "Autoplay"
                            },
                            "AutoplayCheckbox": {
                                "ID": "autoplay-checkbox",
                                "ClassList": [
                                    "options-dialog-sub-element"
                                ],
                                "TickedByDefault": false
                            }
                        },
                        "StateToLoadInputDiv": {
                            "ID": "state-to-load-input-div",
                            "ClassList": [
                                "options-dialog-element"
                            ],
                            "StateToLoadInputLabel": {
                                "ID": "state-to-load-input-label",
                                "ClassList": [
                                    "options-dialog-label"
                                ],
                                "Text": "State to load"
                            },
                            "StateToLoadInput": {
                                "ID": "state-to-load-input",
                                "ClassList": [
                                    "options-dialog-sub-element"
                                ],
                                "Accept": ".json",
                                "MaxFileSize": 5000000
                            }
                        },
                        "TooltipsCheckboxDiv": {
                            "ID": "tooltips-checkbox-div",
                            "ClassList": [
                                "options-dialog-element"
                            ],
                            "TooltipsCheckboxLabel": {
                                "ID": "tooltips-checkbox-label",
                                "ClassList": [
                                    "options-dialog-label"
                                ],
                                "Text": "Tooltips"
                            },
                            "TooltipsCheckbox": {
                                "ID": "tooltips-checkbox",
                                "ClassList": [
                                    "options-dialog-sub-element"
                                ],
                                "TickedByDefault": true
                            }
                        },
                        "MaxNumberOfCyclesInputDiv": {
                            "ID": "max-number-of-cycles-input-div",
                            "ClassList": [
                                "options-dialog-element"
                            ],
                            "MaxNumberOfCyclesInputLabel": {
                                "ID": "max-number-of-cycles-input-label",
                                "ClassList": [
                                    "options-dialog-label"
                                ],
                                "Text": "Max number of cycles"
                            },
                            "MaxNumberOfCyclesInput": {
                                "ID": "max-number-of-cycles-input",
                                "ClassList": [
                                    "options-dialog-sub-element"
                                ]
                            }
                        },
                        "EffortsInputsDiv": {
                            "ID": "efforts-inputs-div",
                            "ClassList": [
                                "options-dialog-element"
                            ],
                            "EffortsInputsLabels": {
                                "ID": "efforts-inputs-labels",
                                "ClassList": [
                                    "options-dialog-label"
                                ],
                                "For": "efforts-inputs",
                                "Text": "Efforts"
                            },
                            "EffortsInputs": {
                                "IDSuffix": "-effort-div",
                                "EffortInputLabel": {
                                    "ClassList": [
                                        "options-dialog-label"
                                    ],
                                    "Text": ""
                                },
                                "EffortInput": {
                                    "IDSuffix": "-effort-input",
                                    "ClassList": [
                                        "effort-option-div"
                                    ]
                                }
                            }
                        },
                        "TeleoraInputDiv": {
                            "ID": "teleora-input-div",
                            "ClassList": [
                                "options-dialog-element"
                            ],
                            "TeleoraInputLabel": {
                                "ID": "teleora-input-label",
                                "ClassList": [
                                    "options-dialog-label"
                                ],
                                "Text": "Teleora mind cores to load"
                            },
                            "TeleoraInput": {
                                "ID": "teleora-input",
                                "ClassList": [
                                    "options-dialog-sub-element"
                                ]
                            }
                        },
                        "OptionsDialogOKButton": {
                            "ID": "options-dialog-ok-button",
                            "ClassList": [
                                "options-dialog-buttons"
                            ],
                            "Text": "OK",
                            "Title": "Close and save the options."
                        },
                        "OptionsDialogCancelButton": {
                            "ID": "options-dialog-cancel-button",
                            "ClassList": [
                                "options-dialog-buttons"
                            ],
                            "Text": "Cancel",
                            "Title": "Close without saving the options."
                        }
                    }
                }
            },
            "SimulationGUI": {
                "SimulationDiv": {
                    "ID": "simulation-div",
                    "ClassList": [],
                    "GridDiv": {
                        "ID": "grid-div",
                        "ClassList": [
                            "grid",
                            "center-aligned"
                        ],
                        "GridTable": {
                            "ID": "grid-table",
                            "ClassList": [
                                "grid-table"
                            ],
                            "GridTableRow": {
                                "IDPrefix": "grid-table-row-",
                                "ClassList": [
                                    "grid-row"
                                ],
                                "GridTableCell": {
                                    "IDPrefix": "grid-table-cell-",
                                    "ClassList": [
                                        "grid-cell"
                                    ],
                                    "ClassListLight": [
                                        "grid-cell-light"
                                    ],
                                    "ClassListDark": [
                                        "grid-cell-dark"
                                    ],
                                    "CellDiv": {
                                        "IDPrefix": "grid-cell-div-",
                                        "ClassList": [
                                            "cell",
                                            "drop-zone"
                                        ],
                                        "CellImage": {
                                            "IDPrefix": "grid-cell-image-",
                                            "ClassList": [
                                                "location-image"
                                            ],
                                            "EmptyImageSrc": "static/images/locations/empty.png",
                                            "GreenAgentNorthImageSrc": "static/images/locations/actor/green_north.png",
                                            "GreenAgentSouthImageSrc": "static/images/locations/actor/green_south.png",
                                            "GreenAgentWestImageSrc": "static/images/locations/actor/green_west.png",
                                            "GreenAgentEastImageSrc": "static/images/locations/actor/green_east.png",
                                            "OrangeAgentNorthImageSrc": "static/images/locations/actor/orange_north.png",
                                            "OrangeAgentSouthImageSrc": "static/images/locations/actor/orange_south.png",
                                            "OrangeAgentWestImageSrc": "static/images/locations/actor/orange_west.png",
                                            "OrangeAgentEastImageSrc": "static/images/locations/actor/orange_east.png",
                                            "WhiteAgentNorthImageSrc": "static/images/locations/actor/white_north.png",
                                            "WhiteAgentSouthImageSrc": "static/images/locations/actor/white_south.png",
                                            "WhiteAgentWestImageSrc": "static/images/locations/actor/white_west.png",
                                            "WhiteAgentEastImageSrc": "static/images/locations/actor/white_east.png",
                                            "UserNorthImageSrc": "static/images/locations/actor/user_north.png",
                                            "UserSouthImageSrc": "static/images/locations/actor/user_south.png",
                                            "UserWestImageSrc": "static/images/locations/actor/user_west.png",
                                            "UserEastImageSrc": "static/images/locations/actor/user_east.png",
                                            "GreenDirtImageSrc": "static/images/locations/dirt/green_dirt.png",
                                            "OrangeDirtImageSrc": "static/images/locations/dirt/orange_dirt.png",
                                            "ObstacleImageSrc": "static/images/locations/obstacle.png",
                                            "DebugGreenAgentNorthImageSrc": "static/images/locations/debug/actor/green_north.png",
                                            "DebugGreenAgentSouthImageSrc": "static/images/locations/debug/actor/green_south.png",
                                            "DebugGreenAgentWestImageSrc": "static/images/locations/debug/actor/green_west.png",
                                            "DebugGreenAgentEastImageSrc": "static/images/locations/debug/actor/green_east.png",
                                            "DebugOrangeAgentNorthImageSrc": "static/images/locations/debug/actor/orange_north.png",
                                            "DebugOrangeAgentSouthImageSrc": "static/images/locations/debug/actor/orange_south.png",
                                            "DebugOrangeAgentWestImageSrc": "static/images/locations/debug/actor/orange_west.png",
                                            "DebugOrangeAgentEastImageSrc": "static/images/locations/debug/actor/orange_east.png",
                                            "DebugWhiteAgentNorthImageSrc": "static/images/locations/debug/actor/white_north.png",
                                            "DebugWhiteAgentSouthImageSrc": "static/images/locations/debug/actor/white_south.png",
                                            "DebugWhiteAgentWestImageSrc": "static/images/locations/debug/actor/white_west.png",
                                            "DebugWhiteAgentEastImageSrc": "static/images/locations/debug/actor/white_east.png",
                                            "DebugUserNorthImageSrc": "static/images/locations/debug/actor/user_north.png",
                                            "DebugUserSouthImageSrc": "static/images/locations/debug/actor/user_south.png",
                                            "DebugUserWestImageSrc": "static/images/locations/debug/actor/user_west.png",
                                            "DebugUserEastImageSrc": "static/images/locations/debug/actor/user_east.png",
                                            "DebugGreenDirtImageSrc": "static/images/locations/debug/dirt/green_dirt.png",
                                            "DebugOrangeDirtImageSrc": "static/images/locations/debug/dirt/orange_dirt.png",
                                            "DebugObstacleImageSrc": "static/images/locations/debug/obstacle.png"
                                        }
                                    }
                                }
                            }
                        }
                    },
                    "DraggablesDiv": {
                        "ID": "draggables-div",
                        "ClassList": [],
                        "GreenAgentDiv": {
                            "ID": "draggable-green-agent-div",
                            "ClassList": [
                                "draggable"
                            ],
                            "GreenAgentImage": {
                                "ID": "draggable-green-agent-image",
                                "ClassList": [
                                    "draggable-image"
                                ],
                                "ImageSrc": "static/images/locations/actor/green_north.png"
                            }
                        },
                        "OrangeAgentDiv": {
                            "ID": "draggable-orange-agent-div",
                            "ClassList": [
                                "draggable"
                            ],
                            "OrangeAgentImage": {
                                "ID": "draggable-orange-agent-image",
                                "ClassList": [
                                    "draggable-image"
                                ],
                                "ImageSrc": "static/images/locations/actor/orange_north.png"
                            }
                        },
                        "WhiteAgentDiv": {
                            "ID": "draggable-white-agent-div",
                            "ClassList": [
                                "draggable"
                            ],
                            "WhiteAgentImage": {
                                "ID": "draggable-white-agent-image",
                                "ClassList": [
                                    "draggable-image"
                                ],
                                "ImageSrc": "static/images/locations/actor/white_north.png"
                            }
                        },
                        "UserDiv": {
                            "ID": "draggable-user-div",
                            "ClassList": [
                                "draggable"
                            ],
                            "UserImage": {
                                "ID": "draggable-user-image",
                                "ClassList": [
                                    "draggable-image"
                                ],
                                "ImageSrc": "static/images/locations/actor/user_north.png"
                            }
                        },
                        "GreenDirtDiv": {
                            "ID": "draggable-green-dirt-div",
                            "ClassList": [
                                "draggable"
                            ],
                            "GreenDirtImage": {
                                "ID": "draggable-green-dirt-image",
                                "ClassList": [
                                    "draggable-image"
                                ],
                                "ImageSrc": "static/images/locations/dirt/green_dirt.png"
                            }
                        },
                        "OrangeDirtDiv": {
                            "ID": "draggable-orange-dirt-div",
                            "ClassList": [
                                "draggable"
                            ],
                            "OrangeDirtImage": {
                                "ID": "draggable-orange-dirt-image",
                                "ClassList": [
                                    "draggable-image"
                                ],
                                "ImageSrc": "static/images/locations/dirt/orange_dirt.png"
                            }
                        }
                    },
                    "SimulationControlsDiv": {
                        "ID": "simulation-controls-div",
                        "ClassList": [],
                        "RunButton": {
                            "ID": "run-button",
                            "ClassList": [
                                "simulation-buttons"
                            ],
                            "ClassListLight": [
                                "simulation-buttons-light"
                            ],
                            "ClassListDark": [
                                "simulation-buttons-dark"
                            ],
                            "Text": "Run",
                            "Title": "Run the simulation.",
                            "HiddenWhileRunning": true,
                            "HiddenWhilePaused": true,
                            "HiddenWhileStopped": false
                        },
                        "PauseButton": {
                            "ID": "pause-button",
                            "ClassList": [
                                "simulation-buttons"
                            ],
                            "ClassListLight": [
                                "simulation-buttons-light"
                            ],
                            "ClassListDark": [
                                "simulation-buttons-dark"
                            ],
                            "Text": "Pause",
                            "Title": "Pause the simulation.",
                            "HiddenWhileRunning": false,
                            "HiddenWhilePaused": true,
                            "HiddenWhileStopped": true
                        },
                        "ResumeButton": {
                            "ID": "resume-button",
                            "ClassList": [
                                "simulation-buttons"
                            ],
                            "ClassListLight": [
                                "simulation-buttons-light"
                            ],
                            "ClassListDark": [
                                "simulation-buttons-dark"
                            ],
                            "Text": "Resume",
                            "Title": "Resume the simulation.",
                            "HiddenWhileRunning": true,
                            "HiddenWhilePaused": false,
                            "HiddenWhileStopped": true
                        },
                        "StopButton": {
                            "ID": "stop-button",
                            "ClassList": [
                                "simulation-buttons"
                            ],
                            "ClassListLight": [
                                "simulation-buttons-light"
                            ],
                            "ClassListDark": [
                                "simulation-buttons-dark"
                            ],
                            "Text": "Stop",
                            "Title": "Stop the simulation.",
                            "HiddenWhileRunning": false,
                            "HiddenWhilePaused": false,
                            "HiddenWhileStopped": true
                        },
                        "ClearButton": {
                            "ID": "clear-button",
                            "ClassList": [
                                "simulation-buttons"
                            ],
                            "ClassListLight": [
                                "simulation-buttons-light"
                            ],
                            "ClassListDark": [
                                "simulation-buttons-dark"
                            ],
                            "Text": "Clear",
                            "Title": "Clear the grid.",
                            "HiddenWhileRunning": true,
                            "HiddenWhilePaused": true,
                            "HiddenWhileStopped": false
                        },
                        "SpeedUpButton": {
                            "ID": "speed-up-button",
                            "ClassList": [
                                "simulation-buttons"
                            ],
                            "ClassListLight": [
                                "simulation-buttons-light"
                            ],
                            "ClassListDark": [
                                "simulation-buttons-dark"
                            ],
                            "Text": "Speed+",
                            "Title": "Speed up the simulation.",
                            "HiddenWhileRunning": false,
                            "HiddenWhilePaused": false,
                            "HiddenWhileStopped": false
                        },
                        "SpeedDownButton": {
                            "ID": "speed-down-button",
                            "ClassList": [
                                "simulation-buttons"
                            ],
                            "ClassListLight": [
                                "simulation-buttons-light"
                            ],
                            "ClassListDark": [
                                "simulation-buttons-dark"
                            ],
                            "Text": "Speed-",
                            "Title": "Speed down the simulation.",
                            "HiddenWhileRunning": false,
                            "HiddenWhilePaused": false,
                            "HiddenWhileStopped": false
                        },
                        "UserDifficultyToggleButton": {
                            "ID": "user-difficulty-toggle-button",
                            "ClassList": [
                                "simulation-buttons"
                            ],
                            "ClassListLight": [
                                "simulation-buttons-light"
                            ],
                            "ClassListDark": [
                                "simulation-buttons-dark"
                            ],
                            "Text": "User",
                            "Title": "Toggle the user difficulty.",
                            "HiddenWhileRunning": false,
                            "HiddenWhilePaused": false,
                            "HiddenWhileStopped": false
                        },
                        "SaveStateButton": {
                            "ID": "save-state-button",
                            "ClassList": [
                                "simulation-buttons"
                            ],
                            "ClassListLight": [
                                "simulation-buttons-light"
                            ],
                            "ClassListDark": [
                                "simulation-buttons-dark"
                            ],
                            "Text": "Save",
                            "Title": "Save the current state of the environment.",
                            "HiddenWhileRunning": true,
                            "HiddenWhilePaused": true,
                            "HiddenWhileStopped": false
                        },
                        "LoadStateButton": {
                            "ID": "load-state-button",
                            "ClassList": [
                                "simulation-buttons"
                            ],
                            "ClassListLight": [
                                "simulation-buttons-light"
                            ],
                            "ClassListDark": [
                                "simulation-buttons-dark"
                            ],
                            "Text": "Load",
                            "Title": "Load a saved state.",
                            "HiddenWhileRunning": true,
                            "HiddenWhilePaused": true,
                            "HiddenWhileStopped": false
                        },
                        "SimulationGuideButton": {
                            "ID": "inner-guide-button",
                            "ClassList": [
                                "simulation-buttons"
                            ],
                            "ClassListLight": [
                                "simulation-buttons-light"
                            ],
                            "ClassListDark": [
                                "simulation-buttons-dark"
                            ],
                            "Text": "Guide",
                            "Title": "Show the guide in a new browser tab.",
                            "URL": "https://github.com/dicelab-rhul/vacuumworld-web-gui/wiki",
                            "HiddenWhileRunning": true,
                            "HiddenWhilePaused": true,
                            "HiddenWhileStopped": false
                        },
                        "SizeUpButton": {
                            "ID": "size-up-button",
                            "ClassList": [
                                "simulation-buttons"
                            ],
                            "ClassListLight": [
                                "simulation-buttons-light"
                            ],
                            "ClassListDark": [
                                "simulation-buttons-dark"
                            ],
                            "Text": "Size+",
                            "Title": "Increase the size of the environemnt by 1.",
                            "HiddenWhileRunning": true,
                            "HiddenWhilePaused": true,
                            "HiddenWhileStopped": false
                        },
                        "SizeDownButton": {
                            "ID": "size-down-button",
                            "ClassList": [
                                "simulation-buttons"
                            ],
                            "ClassListLight": [
                                "simulation-buttons-light"
                            ],
                            "ClassListDark": [
                                "simulation-buttons-dark"
                            ],
                            "Text": "Size-",
                            "Title": "Decrease the size of the environemnt by 1.",
                            "HiddenWhileRunning": true,
                            "HiddenWhilePaused": true,
                            "HiddenWhileStopped": false
                        }
                    }
                }
            }
        },
        "ErrorDiv": {
            "ID": "error-div",
            "ClassList": [],
            "ClassListLight": [
                "error-div-light"
            ],
            "ClassListDark": [
                "error-div-dark"
            ]
        },
        "ToggleThemeDiv": {
            "ID": "toggle-theme-div",
            "ClassList": [
                "toggle-theme-div",
                "center-aligned"
            ],
            "ToggleThemeButton": {
                "ID": "toggle-theme-button",
                "ClassList": [],
                "ClassListLight": [
                    "toggle-theme-button-light"
                ],
                "ClassListDark": [
                    "toggle-theme-button-dark"
                ],
                "TextLight": "Go Dark",
                "TextDark": "Go Light",
                "Title": "Switch between light and dark theme."
            }
        }
    }
}
